export default __webpack_public_path__ + "static/media/ic_arrow_counter_clockwise.3641d3c6.svg";